/**
 * Copyright © Binary Anvil, Inc. All rights reserved.
 * See https://binaryanvil.com/software/license for license details.
 */

/**
 * Extracts all `<script>` elements from the provided HTML string and removes them from the HTML content.
 *
 * @param {string} htmlString - The HTML string from which `<script>` elements will be extracted.
 * @returns {Object} An object containing:
 *   - `scripts`: An array of strings, each representing a `<script>` element found in the HTML string.
 *   - `cleanedHtml`: A string of the HTML content with all `<script>` elements removed.
 *
 * @example
 * const htmlString = '<div><script>alert("Hello")</script><p>Content</p></div>';
 * const { scripts, cleanedHtml } = extractScripts(htmlString);
 * console.log(scripts); // ['<script>alert("Hello")</script>']
 * console.log(cleanedHtml); // '<div><p>Content</p></div>'
 */
export function extractScripts(htmlString:string) {
    const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gi;
    const scripts = [];
    let match;

    while ((match = scriptRegex.exec(htmlString)) !== null) {
        scripts.push(match[0]);
    }

    // Remove scripts from HTML
    const cleanedHtml = htmlString.replace(scriptRegex, '');

    return { scripts, cleanedHtml };
}